import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { LegalModal } from './LegalModal';
type ModalType = 'terms' | 'privacy' | null;
function handleChangeLanguage() {
  try {
    window.localStorage.removeItem('rs_lang');
  } catch (e) {}
  window.location.reload();
}
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#3E2723] border-t border-white/10 py-10" data-id="element-238">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-239">
          <p className="text-white/70 text-sm text-center md:text-left" data-id="element-240">
            © {new Date().getFullYear()} Authentic Mexico: The Resort Secrets.
            All rights reserved.
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-241">
            <button onClick={() => setOpenModal('terms')} className="text-white/80 hover:text-white text-sm font-medium transition-colors underline-offset-4 hover:underline" data-id="element-242">
              Terms of Service
            </button>
            <button onClick={() => setOpenModal('privacy')} className="text-white/80 hover:text-white text-sm font-medium transition-colors underline-offset-4 hover:underline" data-id="element-243">
              Privacy Policy
            </button>
            <button onClick={handleChangeLanguage} className="inline-flex items-center gap-1.5 text-white/80 hover:text-white text-sm font-medium transition-colors underline-offset-4 hover:underline" data-id="element-244">
              <Globe className="w-4 h-4" data-id="element-245" />
              Change Language · Cambiar Idioma
            </button>
          </nav>
        </div>
      </footer>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Terms of Service" data-id="element-246">
        <p className="text-sm text-[#3E2723]/60" data-id="element-247">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-248">
          1. Acceptance of Terms
        </h3>
        <p data-id="element-249">
          By purchasing and downloading{' '}
          <strong data-id="element-250">Authentic Mexico: The Resort Secrets</strong>, you agree to
          these Terms of Service. If you do not agree, please do not complete
          your purchase.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-251">
          2. Digital Product
        </h3>
        <p data-id="element-252">
          This product is a <strong data-id="element-253">digital PDF download</strong>. Upon
          successful payment, you will receive instant access to the file. No
          physical product will be shipped.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-254">
          3. License & Personal Use
        </h3>
        <p data-id="element-255">
          You are granted a non-transferable, non-exclusive license to use this
          PDF for personal cooking and home use only. You may not resell,
          redistribute, copy, share, or publish any part of this content without
          written permission.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-256">
          4. Refund Policy
        </h3>
        <p data-id="element-257">
          Because this is a digital product delivered immediately, all sales are{' '}
          <strong data-id="element-258">final and non-refundable</strong>. Please review the product
          description carefully before purchasing.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-259">
          5. Disclaimer
        </h3>
        <p data-id="element-260">
          The recipes and ingredient substitutions provided are for
          informational purposes. We are not responsible for allergic reactions,
          dietary issues, or any health-related concerns arising from preparing
          or consuming the recipes. Always check ingredients for personal
          allergens.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-261">
          6. Intellectual Property
        </h3>
        <p data-id="element-262">
          All recipes, photography, design, and written content are protected by
          copyright. Unauthorized reproduction or distribution is strictly
          prohibited.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-263">
          7. Changes to Terms
        </h3>
        <p data-id="element-264">
          We reserve the right to modify these Terms at any time. Continued use
          of the product after changes constitutes acceptance of the updated
          Terms.
        </p>
      </LegalModal>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Privacy Policy" data-id="element-265">
        <p className="text-sm text-[#3E2723]/60" data-id="element-266">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-267">
          1. Information We Collect
        </h3>
        <p data-id="element-268">
          When you purchase{' '}
          <strong data-id="element-269">Authentic Mexico: The Resort Secrets</strong>, we collect only
          the information necessary to fulfill your order, including your name,
          email address, and payment details (processed securely by our payment
          provider).
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-270">
          2. How We Use Your Information
        </h3>
        <p data-id="element-271">Your information is used solely to:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-272">
          <li data-id="element-273">Process your purchase and deliver the digital PDF.</li>
          <li data-id="element-274">Send you a receipt and download link.</li>
          <li data-id="element-275">
            Send occasional product updates or new recipe releases (you may
            unsubscribe at any time).
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-276">
          3. Payment Security
        </h3>
        <p data-id="element-277">
          All payments are processed through trusted, PCI-compliant third-party
          providers. We <strong data-id="element-278">do not store</strong> your credit card or
          payment details on our servers.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-279">
          4. Cookies & Analytics
        </h3>
        <p data-id="element-280">
          We may use cookies and basic analytics tools to understand site usage
          and improve your experience. These tools do not collect personally
          identifiable information unless you provide it.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-281">
          5. Sharing of Information
        </h3>
        <p data-id="element-282">
          We <strong data-id="element-283">never sell, rent, or trade</strong> your personal
          information. Data is only shared with service providers (e.g. payment
          processor, email delivery) strictly to fulfill your order.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-284">
          6. Your Rights
        </h3>
        <p data-id="element-285">
          You may request access to, correction of, or deletion of your personal
          data at any time. You may also opt out of marketing communications
          using the unsubscribe link in any email.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-286">
          7. Data Retention
        </h3>
        <p data-id="element-287">
          We retain your purchase information only as long as necessary for
          legal, tax, and customer service purposes.
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-288">
          8. Changes to This Policy
        </h3>
        <p data-id="element-289">
          This Privacy Policy may be updated periodically. The latest version
          will always be available on this page.
        </p>
      </LegalModal>
    </>;
}